export default __webpack_public_path__ + "static/media/contactusbanner1.bcce79b0.jpg";